import { useMemo } from "react";

// Slow-drifting gold dust particles for the hero.
export const GoldParticles = ({ count = 26 }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = Math.random() * 4 + 1.5;
        return {
          id: i,
          left: Math.random() * 100,
          size,
          duration: Math.random() * 18 + 14,
          delay: Math.random() * 16,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          className="gold-dust"
          style={{
            left: `${p.left}%`,
            bottom: "-20px",
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default GoldParticles;
